/* global t */
// Help articles for purchases, inbox and transactions. Merged into helpArticles() in help-articles.jsx.
// Screenshots use the PlummeDEMO business so no customer data is exposed.
window.PlummeHelpArticlePacks = (window.PlummeHelpArticlePacks || []).concat([() => ({
  inbox: { id: 'inbox', title: t('ha.inbox.title'), category: t('ha.cat.purchase'), read: t('ha.read3'), route: 'innboks',
    keywords: t('ha.inbox.keywords'),
    lead: t('ha.inbox.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.inbox.arrive'), text: t('ha.inbox.arriveText') },
    { t: 'tip', kind: 'tip', title: t('ha.inbox.email'), text: t('ha.inbox.emailText') },
    { t: 'step', n: 2, title: t('ha.inbox.paidFrom'), text: t('ha.inbox.paidFromText') },
    { t: 'step', n: 3, title: t('ha.inbox.check'), text: t('ha.inbox.checkText') },
    { t: 'step', n: 4, title: t('ha.inbox.post'), text: t('ha.inbox.postText') },
    { t: 'tip', kind: 'warn', title: t('ha.inbox.duplicate'), text: t('ha.inbox.duplicateText') },
    { t: 'heading', text: t('ha.inbox.many') },
    { t: 'para', text: t('ha.inbox.manyText') },
    { t: 'heading', text: t('ha.inbox.tidy') },
    { t: 'para', text: t('ha.inbox.tidyText') }]
  },
  purchase: { id: 'purchase', title: t('ha.purchase.title'), category: t('ha.cat.purchase'), read: t('ha.read3'), route: 'nyttkjop',
    keywords: t('ha.purchase.keywords'),
    lead: t('ha.purchase.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.purchase.type'), text: t('ha.purchase.typeText') },
    { t: 'step', n: 2, title: t('ha.purchase.voucher'), text: t('ha.purchase.voucherText') },
    { t: 'step', n: 3, title: t('ha.purchase.details'), text: t('ha.purchase.detailsText') },
    { t: 'tip', kind: 'info', title: t('ha.purchase.remembered'), text: t('ha.purchase.rememberedText') },
    { t: 'step', n: 4, title: t('ha.purchase.lines'), text: t('ha.purchase.linesText') },
    { t: 'step', n: 5, title: t('ha.purchase.save'), text: t('ha.purchase.saveText') },
    { t: 'tip', kind: 'tip', title: t('ha.purchase.inboxFirst'), text: t('ha.purchase.inboxFirstText') }]
  },
  freePosting: { id: 'freePosting', title: t('ha.freePosting.title'), category: t('ha.cat.purchase'), read: t('ha.read2'), route: 'fripostering',
    keywords: t('ha.freePosting.keywords'),
    lead: t('ha.freePosting.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.freePosting.date'), text: t('ha.freePosting.dateText') },
    { t: 'step', n: 2, title: t('ha.freePosting.lines'), text: t('ha.freePosting.linesText') },
    { t: 'step', n: 3, title: t('ha.freePosting.balance'), text: t('ha.freePosting.balanceText') },
    { t: 'step', n: 4, title: t('ha.freePosting.register'), text: t('ha.freePosting.registerText') },
    { t: 'tip', kind: 'warn', title: t('ha.freePosting.careful'), text: t('ha.freePosting.carefulText') }]
  },
  suppliers: { id: 'suppliers', title: t('ha.suppliers.title'), category: t('ha.cat.purchase'), read: t('ha.read2'), route: 'leverandorer',
    keywords: t('ha.suppliers.keywords'),
    lead: t('ha.suppliers.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.suppliers.add'), text: t('ha.suppliers.addText') },
    { t: 'figure', src: 'src/img/help/suppliers-new.png', caption: t('ha.suppliers.add') },
    { t: 'step', n: 2, title: t('ha.suppliers.defaults'), text: t('ha.suppliers.defaultsText') },
    { t: 'step', n: 3, title: t('ha.suppliers.follow'), text: t('ha.suppliers.followText') },
    { t: 'tip', kind: 'info', title: t('ha.suppliers.archive'), text: t('ha.suppliers.archiveText') }]
  },
  transactions: { id: 'transactions', title: t('ha.transactions.title'), category: t('ha.cat.purchase'), read: t('ha.read3'), route: 'allebilag',
    keywords: t('ha.transactions.keywords'),
    lead: t('ha.transactions.lead'),
    blocks: [
    { t: 'step', n: 1, title: t('ha.transactions.find'), text: t('ha.transactions.findText') },
    { t: 'step', n: 2, title: t('ha.transactions.open'), text: t('ha.transactions.openText') },
    { t: 'step', n: 3, title: t('ha.transactions.attach'), text: t('ha.transactions.attachText') },
    { t: 'heading', text: t('ha.transactions.fix') },
    { t: 'para', text: t('ha.transactions.fixText') },
    { t: 'tip', kind: 'warn', title: t('ha.transactions.locked'), text: t('ha.transactions.lockedText') },
    { t: 'tip', kind: 'info', title: t('ha.transactions.invoices'), text: t('ha.transactions.invoicesText') }]
  }
})]);
